import {IonLabel, IonCard, IonCardContent} from "@ionic/react";
import styles from "./styles.module.scss";
import React from "react";
import {formatLongDate} from "../../../../utils/helpers/date";

export const NotificationCardView = ({
                                       notifications,
                                       selectNotification,
                                     }) => {
  return (
    <>
      {
        notifications?.map((notification, index) => {
          return (
            <IonCard>
              <IonCardContent
                onClick={()=>selectNotification(notification?.notification_id)}
                key={index}
                className={notification.read ? styles.read : styles.unread}>

                <IonLabel className="ion-text-wrap">
                  <h3>{notification?.notification_title}</h3>
                  <p>{formatLongDate(notification?.date)}</p>
                </IonLabel>

              </IonCardContent>
            </IonCard>
          )
        })
      }
    </>
  )
}